<script>
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";

export default {
  name: "MyHorizontalScroll",
  components: {
    HorizontalScroll,
  },
  data() {
    return {
      items: [
        {
          title: "제주도",
          content: "온 가족이 즐기는 순천 여행 1박 2일 여행 가즈아",
          image: "https://picsum.photos/id/1015/600/800",
          link: "https://naver.com",
        },
        {
          title: "울릉도",
          content: "울릉도",
          image: "https://picsum.photos/id/1019/600/800",
          link: "https://naver.com",
        },
        {
          title: "송도",
          content: "송도",
          image: "https://picsum.photos/id/1039/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1042/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1044/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1057/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1063/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1076/600/800",
          link: "https://naver.com",
        },
        {
          title: "제주도",
          content: "제주도",
          image: "https://picsum.photos/id/1083/600/800",
          link: "https://naver.com",
        },
      ],
    };
  },
};
</script>

<style scoped>
.horizontal-scroll {
  display: flex;
  width: 100%;
  height: 250px;
  /* border: solid 2px #2c3e50; */
}
.outer {
  display: flex;
  flex: 1;
  width: auto;
  height: 100%;
}

.content-img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.inner-content {
  flex-shrink: 0;
  width: 120px;
  height: 150px;
}

@media (min-width: 640px) {
  .inner-content {
    width: 150px;
    height: 180px;
  }
}

@media (min-width: 768px) {
  .inner-content {
    width: 180px;
    height: 210px;
  }
}

@media (min-width: 1024px) {
  .horizontal-scroll {
    height: 280px;
  }

  .inner-content {
    width: 210px;
    height: 240px;
  }
}

.content-desc {
  overflow: hidden;
  text-overflow: ellipsis;
}

.inner-content:not(:first-of-type) {
  margin-left: 15px;
}
</style>
